import { Injectable } from "@angular/core";
import { StateService } from "@uirouter/core";
import { ProjectService } from "../models/project.service";
import { RememberService } from "../remember/remember.service";

@Injectable()
export class RootUrlHandlerService {
  private REMEMBER_KEY = "projects.lastViewed";

  constructor(
    private $state: StateService,
    private projectService: ProjectService,
    private rememberService: RememberService,
  ) {}

  public goToDefaultState() {
    const lastViewedId = parseInt(
      this.rememberService.get(this.REMEMBER_KEY, "0") as string,
      10,
    );

    if (lastViewedId < 1) {
      return this.goToAccountOverview();
    }

    return this.projectService
      .query()
      .toPromise()
      .then((data: any) => {
        data.projects = data.projects || [];
        for (const project of data.projects) {
          if (project.id === lastViewedId) {
            return this.goToProject(lastViewedId);
          }
        }
        return this.goToAccountOverview();
      })
      .catch(() => this.goToAccountOverview());
  }

  private goToAccountOverview() {
    return this.$state.target("account-overview", {}, { reload: true });
  }

  private goToProject(projectId: number) {
    return this.$state.target(
      "project-errors",
      { projectId },
      { reload: true },
    );
  }
}
